// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  url_configuracao: '/api/integracao/v1/configuracoes',
  nomeVersao: '2.3.0-RC19-260904',
  app_name: 'GEEO',
  caminho_pagina_inicial: '/dashboards',
  caminho_pagina_login: '/seguranca/login',
  url_manual_healthlog: 'https://docs.google.com/document/d/1_RsaOHe5_Uct58hHqPkiyBgGkd-9zGbaUvfBslHH8Oo/view',
  brasil_centroid: {
    lat: -14.2400732,
    lng: -53.1805017
  },
  production: false,
  localizador_max_size: 10,
  paginacao_size: 20,
  default_debounce_time: 800,
  intervalo_em_minutos_do_version_check: 60,
  pesquisa_paciente_topbar_max_size: 10,
  url_do_roteirizador: '/api/gis/roteirizador/v1/roteirizador',
  credencial_api_authorization_header_basic: 'Z2VvbWVkOkBnMzBtM2RA',
  firebase: {
    apiKey: "AIzaSyCJFfKxtYX0_YMosQZPqPd6v6BoLzGEF2U",
    authDomain: "geomed-dev.firebaseapp.com",
    databaseURL: "https://geomed-dev.firebaseio.com",
    projectId: "geomed-dev",
    storageBucket: "geomed-dev.appspot.com",
    messagingSenderId: "454310980941",
    appId: "1:454310980941:web:db653d0ae4438abed11b04"
  },
  googleMaps: {
    apiKey: "AIzaSyCJFfKxtYX0_YMosQZPqPd6v6BoLzGEF2U"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
